import React from "react";
import { connect } from "react-redux";
import {Producto_Comercial} from '../constants/constants'
import { getVelidateIsMascota } from "../mascotas/util-functions";

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza
	};
};

class ContratantePoliza extends React.Component {
	generateFullName = () => this.props.poliza.contratante.nombres + " " + this.props.poliza.contratante.apellidoPaterno + " " + this.props.poliza.contratante.apellidoMaterno;

	render() {
		let bGrupo = (this.props.poliza.generales.cveClasificacionSeguro === "05" || this.props.poliza.generales.cveClasificacionSeguro === "06" );
		let contDireccion = "", contNumExt = "", contNumInt = "", contMunicipio = "", contEstado = "", contCorreo = "", contCP = "", contColonia = "", contTelefono = "";
		let imgContratante;
		const isMascotasPoliza = getVelidateIsMascota(this.props.poliza.generales.productoComercial.trim());

		let nombre = undefined;

		if(this.props.poliza.generales.cveClasificacionSeguro === "SC") {
			nombre = this.props.poliza.contratante.nombres.trim() + this.props.poliza.contratante.apellidoPaterno.trim() + this.props.poliza.contratante.apellidoMaterno.trim();
			if(nombre === "") {
				nombre = this.props.poliza.contratante.razonSocial;
			} else {
				nombre = this.props.poliza.contratante.nombres + " " + this.props.poliza.contratante.apellidoPaterno + " " + this.props.poliza.contratante.apellidoMaterno;
			}
		} else if(this.props.poliza.contratante.razonSocial !== undefined && this.props.poliza.contratante.razonSocial.trim() !== "" && (this.props.poliza.generales.cveClasificacionSeguro === "01" || this.props.poliza.generales.cveClasificacionSeguro === "02")){
			nombre = this.props.poliza.contratante.razonSocial;
		} else if (bGrupo){
			if (this.props.poliza.contratante.razonSocial != "") {
				nombre = this.props.poliza.contratante.razonSocial;
			} else {
				nombre = this.props.poliza.contratante.razonSocialPadre ;
			}
			nombre = isMascotasPoliza ? this.generateFullName() : nombre;// validacíón solo para poliza mascota

		} else {
			nombre = this.generateFullName();
		}

		if ( this.props.poliza.contratante.direccion && this.props.poliza.contratante.direccion.length > 0 ) {
			contDireccion = this.props.poliza.contratante.direccion[0].calle;
			contNumInt = this.props.poliza.contratante.direccion[0].numInt;
			contNumExt = this.props.poliza.contratante.direccion[0].numExt;
			contMunicipio = this.props.poliza.contratante.direccion[0].municipio;
			contEstado = this.props.poliza.contratante.direccion[0].estado;
			contCP = this.props.poliza.contratante.direccion[0].codPostal;
			contColonia = this.props.poliza.contratante.direccion[0].colonia;
		}

		if ( this.props.poliza.contratante.mediosContacto && this.props.poliza.contratante.mediosContacto.correo && this.props.poliza.contratante.mediosContacto.correo.length > 0 ) {
			contCorreo = this.props.poliza.contratante.mediosContacto.correo[0];
		}

		if ( this.props.poliza.contratante.mediosContacto && this.props.poliza.contratante.mediosContacto.telefono && this.props.poliza.contratante.mediosContacto.telefono.length > 0 ) {
			contTelefono = this.props.poliza.contratante.mediosContacto.telefono[0];
		}

		switch (this.props.poliza.generales.cveRamo) {
		case "A":
			imgContratante = require("../img/circle-contratante.svg");
			break;
		case "G":
			// imgContratante = require("../img/circle-contratante-gm.svg");
			imgContratante = require("../img/circle-contratante.svg");
			break;
		case "D":
			// imgContratante = require("../img/circle-contratante-danios.svg");
			imgContratante = require("../img/circle-contratante.svg");
			break;
		case "V":
			// imgContratante = require("../img/circle-contratante-vida.svg");
			imgContratante = require("../img/circle-contratante.svg");
			break;
		}

		return <div className="card perfil-card">
			<i><img src={ imgContratante } alt="" className="pad-right-10" /></i><span className="blue-text detalle-seccion">Contratante</span>
			<div className="row">
				<div className="col-md-6 col-xs-12">
					<ul className="list-divider mt-25">
						<li className="clearfix">
							<div className="pull-left">
								<p><b>Nombre</b></p>
							</div>
							<div className="pull-right">
								<div className="gray-text texto15">
									<p name="contnombre">{ nombre}</p>
								</div>
							</div>
						</li>
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>RFC</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contrfc">{ this.props.poliza.contratante.rfc }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>CURP</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contcurp">{ this.props.poliza.contratante.curp }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Correo electrónico</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contcorreo">{ contCorreo }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Teléfono</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="conttelefono">{ contTelefono }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Estado / Ciudad</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contEstado">{ contEstado }</p>
									</div>
								</div>
							</li>
						}
					</ul>
				</div>
				<div className="col-md-6 col-xs-12">
					<ul className="list-divider mt-25">
						{ (bGrupo && !isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>RFC</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contrfc">{ this.props.poliza.contratante.rfc }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Dirección</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contdireccion">{ contDireccion } </p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Número Interior</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contnumInterior">{ contNumInt }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Número exterior</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contnumExterior">{ contNumExt }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Colonia</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="colonia">{ contColonia }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Código postal</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contcodigoPostal">{ contCP }</p>
									</div>
								</div>
							</li>
						}
						{ (!bGrupo || isMascotasPoliza ) &&
							<li className="clearfix">
								<div className="pull-left">
									<p><b>Delegación / Municipio</b></p>
								</div>
								<div className="pull-right">
									<div className="gray-text texto15">
										<p name="contdelegacionMunicipio">{ contMunicipio }</p>
									</div>
								</div>
							</li>
						}
					</ul>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState)(ContratantePoliza);


// WEBPACK FOOTER //
// ./src/home/contratante.cmpt.js